import type { ApiEndpoint } from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kAudioDescriptionRoute = "/audio-description";

export const kAudioDescriptionModels = [
    "gemini_flash_3",
    "gemini_pro_3",
    "qwen25_omni",
    "qwen3_omni",
    "gemini_3_1_pro",
    "gemini_3_1_flash_lite",
    "gpt_audio",
    "gpt_audio_mini",
    "mimo_v2_omni",
] as const;

export type AudioDescriptionModel = (typeof kAudioDescriptionModels)[number];

export const kAudioDescriptionPromptMaxLength = 10_000;

export interface AudioDescriptionRequestBody {
    inputFileKey: string;
    model?: AudioDescriptionModel;
    prompt?: string;
}

export const isAudioDescriptionRequestBody = (
    value: unknown,
): value is AudioDescriptionRequestBody =>
    isObject(value) && typeof value.inputFileKey === "string";

export interface AudioDescriptionSuccessResponse {
    ok: true;
    descriptionUrl: string;
}

export const isAudioDescriptionSuccessResponse = (
    value: unknown,
): value is AudioDescriptionSuccessResponse =>
    isObject(value) && value.ok === true && typeof value.descriptionUrl === "string";

export const kAudioDescriptionEndpoint: ApiEndpoint<
    AudioDescriptionRequestBody,
    AudioDescriptionSuccessResponse
> = {
    route: kAudioDescriptionRoute,
    label: "Audio Description",
    source: "Atlantis",
    category: "Audio IQ",
    description:
        "Generates a natural language description of an audio file using a multimodal AI model.",
    isRequestBody: isAudioDescriptionRequestBody,
    isSuccessResponse: isAudioDescriptionSuccessResponse,
};
